<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <div class="btn_box">
          <div class="main-title">模特管理</div>
          <!-- <div class="search_box"><el-button size="medium" class="search" @click="changeContact('add','')"  type="primary">添加联系人</el-button></div> -->
        </div>
<!--        <el-form :inline="true" :model="formInline" label-position="top" class="demo-form-inline">-->
<!--          <el-row :gutter="24" class="searchBox">-->
<!--            <el-col :xl="6" :lg="5" :md="12" :sm="24" :xs="24">-->
<!--              <el-form-item label="姓名">-->
<!--                <input class="searchInput" type="text" placeholder="请输入">-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :xl="6" :lg="5" :md="12" :sm="24" :xs="24">-->
<!--              <el-form-item label="身份证号">-->
<!--                <input class="searchInput" type="text" placeholder="请输入">-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :xl="6" :lg="5" :md="12" :sm="24" :xs="24">-->
<!--              <el-form-item label="在读院校">-->
<!--                <input class="searchInput" type="text" placeholder="请输入">-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--            <el-col :xl="6" :lg="9" :md="12" :sm="24" :xs="24">-->
<!--              <el-form-item label="" class="searchFooter">-->
<!--                <button class="btn search-btn" @click.stop="getList">查询</button>-->
<!--                <button class="btn">重置</button>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-form>-->
        <div class="btnBox">
          <div>
            <span class="searchTxt">已登记模特列表（已登记{{total}}/{{model_count}}）</span>
            <span class="explanatoryText">
              <img class="searchIcon" src="../assets/Instructions.jpg" alt="">
              <!-- zhang 说明文字 -->
              <dev class="explanatoryBox">
                <div>当前登记名额为{{model_count}}人，如需更多名额，请联系协会：</div>
                <div class="mobile">电话：18610019888</div>
                <div>邮箱：aschaig@163.com</div>
              </dev>
            </span>
          </div>
          <div class="searchBtnBox">
            <button v-if="model_count!=0&&total<model_count" class="btn search-btn" @click="changeContact('add','')">新建</button>
            <!--            <button class="btn line-btn" @click="payDescription">缴费说明</button>-->
            <!--            <button class="btn line-btn" @click="toPayment">填写付款信息</button>-->
          </div>
        </div>
        <div class="invitate-wrap">
          <!-- 列表 -->
          <el-table
              :data="tableData"
              style="width: 100%"
              :cell-style="{textAlign: 'center'}"
              :header-cell-style="{background:'#EDF1F7',color: '#333', textAlign: 'center'}"
          >
            <el-table-column
                width="100"
                label="照片">
              <template v-slot="scope">
                <el-image class="photo" :src="scope.row.photo"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="name"
                label="姓名"
                width="100">
            </el-table-column>
            <el-table-column
                prop="gender"
                label="性别"
                width="100">
            </el-table-column>
            <el-table-column
                width="200"
                prop="create_time"
                label="创建时间">
            </el-table-column>
            <el-table-column
                width="100"
                prop="sign_company"
                label="签约单位">
            </el-table-column>
            <el-table-column
                width=""
                prop="desc"
                label="描述">
            </el-table-column>
<!--            <el-table-column-->
<!--                width="230"-->
<!--                label="状态">-->
<!--              <template v-slot="scope">-->
<!--                <span class="status sicon1" v-if="scope.row.status==1">已登记</span>-->
<!--                <span class="status sicon1" v-if="scope.row.status==2">已审核</span>-->
<!--                <span class="status sicon2" v-if="scope.row.status==3">待缴费</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column
                fixed="right"
                label="操作"
                width="120">
              <template v-slot="scope">
                <el-button
                    @click.native.prevent="Details('see',scope.row)"
                    type="text"
                    size="small">
                  查看
                </el-button>
                <el-button
                    @click.native.prevent="Details('edit',scope.row)"
                    type="text"
                    size="small">
                  编辑
                </el-button>
                <el-button
                    @click.native.prevent="delRow(scope.row)"
                    type="text"
                    size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paginationbox">
          <el-pagination
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>

      <el-dialog
          title=""
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          :before-close="handleClose">
        <div>
          <div class="dialogTitle">缴费说明</div>
          <div class="jfContent">
            上传模特信息后，需缴纳登记费用100元/人，缴纳完毕后自动进入模特库。<br>
            缴费方式只支持对公转账，缴费前请联系：<br>
            某某某 手机号：1888888888 邮箱：666@666.com
          </div>
          <div class="dialogLine"></div>
          <div class="dialogTitle">收款信息</div>
          <div class="jfContent">
            单位名称：索奇智能（北京）科技有限公司<br>
            开户账号：XXXXXXXXXX<br>
            开户账号：XXXXXXXXXX
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="btn next_btn" @click="dialogVisible = false">我已知晓</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  contactsLists,
  delContacts, MemberModels_delete, MemberModels_detail, MemberModels_lists
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: {top, navMenu},
  name: "attestation",
  data() {
    return {
      userdata: JSON.parse(localStorage.getItem("userdata")),
      dialogVisible: false,
      formInline: {
        user: '',
        region: ''
      },
      loading: false,
      active: 0,
      model_count:JSON.parse(localStorage.getItem("userdata")).limit_model_count,
      total: 1,
      page_no: 1,
      page_size: 10,
      tableData: [],
      mark: ''
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/aptitude";
    });
    this.active = index;
    // this.id = this.$route.query.id;
    this.mark = this.$route.query.mark;

    this.getList();
  },
  methods: {
    // zhang 缴费说明
    payDescription() {
      this.dialogVisible = true;
    },
    //zhang 付款信息
    toPayment() {
      this.$router.push({
        name: '/paymentInfoList'
      })
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    // zhang 新建
    changeContact(type, contacts_long_id) {
      this.$router.push({
        path: '/contactPerson',
        query: {
          type,
          contacts_long_id,
          mark: this.mark
        }
      })
    },
    // zhang 获取列表数据
    getList() {
      let data = this.$qs.stringify({
        page_no: this.page_no,
        page_size: this.page_size,
        type: this.userdata.type,
      });
      MemberModels_lists(data).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.lists;
          this.total = res.data.count
        }
      })
          .catch((err) => {
            console.log(err);
          });
    },

    Details(type, row) {
      let data = this.$qs.stringify({model_long_id: row.model_long_id});
      MemberModels_detail(data).then((res) => {
        if (res.code == 1) {
          this.$router.push({
            path: '/contactPerson',
            query: {
              type,
              data: res.data,
              mark: this.mark
            }
          })
        }
      })
          .catch((err) => {
            console.log(err);
          });
    },

    delRow(row) {
      this.$confirm("确定要删除此条数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            let data = {
              model_long_id: row.model_long_id
            }
            MemberModels_delete(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.getList()
              }
            }).catch((err) => {
              console.log(err);
            });


          })


    },


    // 分页相关
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page_no = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.dialogTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.88);
}

.jfContent {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
  line-height: 22px;
  margin-top: 8px;
}

.dialogLine {
  width: 100%;
  height: 1px;
  background: #EEEEEE;
  margin: 10px 0;
}

/deep/ .el-dialog {
  width: 480px !important;
  height: 340px !important;
  background: #FFFFFF;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}

/deep/ .el-dialog__body {
  padding: 20px 24px;
  box-sizing: border-box;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

/deep/ .el-dialog__header {
  display: none;
}

.explanatoryText {
  display: inline-block;
  position: relative;
}

.explanatoryText:hover .explanatoryBox {
  display: block;
}

.explanatoryBox {
  display: none;
  width: 340px;
  padding: 20px;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 1px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: absolute;
  z-index: 9999;
  top: 23px;
  left: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;

  .mobile {
    margin: 10px 0 8px;
  }
}

.paginationbox {
  //width: 100%;
  //position: absolute;
  //bottom: 30px;
  //left: 0;
}

.searchIcon {
  width: 17px;
  height: 17px;
  vertical-align: middle;
  margin-left: 7px;
  cursor: pointer;
}

.searchTxt {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}

.searchBtnBox {
  margin-right: 50px;
  //margin-top: 10px;
}

.btnBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}

.status {
  display: inline-block;
  width: 56px;
  height: 24px;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #FFFFFF;
  text-align: center;
  line-height: 24px;
}

.sicon1 {
  background: #44D7B6;
}

.sicon2 {
  background: #FF4D4F;
}

/deep/ .el-button {
  position: initial;
}

.photo {
  width: 66px;
  height: 66px;
}

.btn_box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
}
</style>
<style lang="scss">
@media only screen and (max-width: 1280px) {

}

@media only screen and (max-width: 767px) {


}
</style>